<template>
    <div id="footer">
        <div id="table-selection-info">
            <span>{{ articleCount }} angezeigte Artikel</span>
            <span>{{ articleCountWithPrice }} bepreiste Artikel</span>
            <span>
                <span id="table-highlight">{{ selectedArticleCount }}</span>
                ausgewählt
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: {
        articleCount: {
            type: Number,
            default: 0
        },
        articleCountWithPrice: {
            type: Number,
            default: 0
        },
        selectedArticleCount: {
            type: Number,
            default: 0
        }
    }
};
</script>

<style lang="scss" scoped>
#footer {
}
#table-selection-info {
    display: flex;
    justify-content: space-between;
    padding: 4px 8px;
    color: $gray-light;
    margin: 5px;
    border-radius: 4px;
    overflow-x: hidden;
    border: 1px solid #ced4da;
}

#table-selection-info #table-highlight {
    color: $black;
}
</style>
